import React from "react";
import { Col } from "reactstrap";

const MainContainer = (props) => {
  return <Col>{props.children}</Col>;
};

export default MainContainer;
